import { useStrictInstance } from '@funtech-int/rival-react';
import { requestIdManagerRef } from '@funtech-int/yango-shared';

export function useRequestIdManager() {
    return useStrictInstance(requestIdManagerRef);
}
